import { useState, useEffect } from "react";
import PropTypes from "prop-types"; // Pour valider les props
import apiClient from "../Api/apiConfig";

export default function ForumReplies({ postId }) {
  const [replies, setReplies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReplies = async () => {
      // Validation de l'ID du post
      if (!postId || typeof postId !== "string") {
        console.error("[ForumReplies] L'ID du post est invalide :", postId);
        setError("L'ID du post est invalide.");
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        console.log(`[ForumReplies] Tentative de récupération des réponses pour le postId : ${postId}`);
        const response = await apiClient.get(`/api/forum-posts/${postId}/replies`);
        console.log("[ForumReplies] Réponses reçues du serveur :", response.data);

        // Mise à jour des réponses
        setReplies(response.data || []);
      } catch (err) {
        console.error("[ForumReplies] Erreur lors du chargement des réponses :", err.message);
        if (err.response) {
          console.error("[ForumReplies] Réponse de l'API :", {
            status: err.response.status,
            data: err.response.data,
          });
        }
        setError("Impossible de charger les réponses. Veuillez réessayer plus tard.");
      } finally {
        setLoading(false);
      }
    };

    fetchReplies();
  }, [postId]);

  if (loading) {
    return <p className="text-gray-500 dark:text-gray-300">Chargement des réponses...</p>;
  }

  if (error) {
    console.error("[ForumReplies] Message d'erreur affiché à l'utilisateur :", error);
    return <p className="text-red-500">{error}</p>;
  }

  return (
    <div className="mt-4 pl-6 border-l-2 border-gray-200 dark:border-gray-700">
      {replies.length > 0 ? (
        replies.map((reply) => (
          <div key={reply.id} className="mt-4">
            <div className="text-sm font-medium text-gray-900 dark:text-white">
              {reply.authorName || "Auteur inconnu"}
            </div>
            <p className="text-gray-600 dark:text-gray-300">{reply.content || "Contenu vide"}</p>
          </div>
        ))
      ) : (
        <p className="text-gray-500 dark:text-gray-300">Aucune réponse pour l'instant.</p>
      )}
    </div>
  );
}

// Validation des props
ForumReplies.propTypes = {
  postId: PropTypes.string.isRequired, // L'ID doit être une chaîne non vide
};
